import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=2ac5f944&scoped=true&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=2ac5f944&prod&scoped=true&lang=css&"
import style1 from "./breadcrumbs.vue?vue&type=style&index=1&id=2ac5f944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5f944",
  null
  
)

export default component.exports